<template>
  <div
    class="shop-category-list-item featured"
    v-for="item of FEATURED_LIST"
    :key="item.name"
    @click="router.push(item.path)"
  >
    <span class="prefix">{{ item.prefix }}</span>
    {{ TRANSLATE_MAP[language.current][item.name] }}
    <img
      class="shop-category-list-item__icon"
      src="@/assets/layouts/choices.svg"
    >
  </div>
</template>

<script setup>
import { FEATURED_LIST, TRANSLATE_MAP } from '@/utils/constants'
import { useLanguageStore } from '@/pinia/language'

const router = useRouter()
const language = useLanguageStore()
</script>

<style lang="less" scoped>
.shop-category-list-item {
  position: relative;

  &.featured {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 0 8px;
    overflow: unset;

    .prefix {
      font-size: 14px;
      line-height: 16px;
    }
  }

  &__icon {
    position: absolute;
    top: -9px;
    right: 4px;
  }
}
</style>
